<template>
  <div>
    <b-col>
      <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <flat-picker :key="rerenderStartDate"
            :isDisabled="activeService"
            @onDateChanged="(unixDate) => {vodService.start_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(vodService.start_date ? vodService.start_date : new Date()/1000 ).toDate())}"
            />
      </b-form-group>
      <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="activeService">
        <flat-picker :key="rerenderExpireDate"
            :isDisabled="true"
            @onDateChanged="(unixDate) => {endDate = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(endDate ? endDate : new Date()/1000 ).toDate())}"
            />
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
        <b-input-group>
          <b-form-input type="text" disabled v-model="serviceStats.charged_in_curr_period"/>
          <b-input-group-append>
            <b-button variant="info" size="sm" :disabled="!isEdit">{{ $t('Details') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="vodService.cost_coef" :disabled="activeService"/>
      </b-form-group>
      <div v-if="fullVODData.vod_service_data">
        <b-form-group label-align="right" :label="$t('IPTV access card')" :disabled="isEdit" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="fullVODData.vod_service_data.type == 0">
          <b-form-select :options="accessCards" v-model="vodService.comment"/>
        </b-form-group>
      </div>
    </b-col>

    <modal-ok-cancel @save="saveVodService" v-if="!activeService" @cancel="hideSelectService"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    tariffLinkId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      rerenderStartDate: 0,
      rerenderExpireDate: 0,
      activeService: false,
      serviceStats: null,
      endDate: 0,
      vodService: {
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tariff_link_id': 0,
        'start_date': moment().unix(),
        'cost_coef': 100,
        'comment': ''
      }
    }
  },
  methods: {
    saveVodService () {
      let tmpVodService = JSON.parse(JSON.stringify(this.vodService))
      tmpVodService.tariff_link_id = this.tariffLinkId ? this.tariffLinkId : 0
      tmpVodService.start_date = this.vodService.start_date
      tmpVodService.cost_coef = this.vodService.cost_coef / 100
      tmpVodService.comment = String(this.vodService.comment)
      if (this.isEdit) {
        tmpVodService.slink_id = this.currentService.service_link_id
      } else {
        tmpVodService.account_id = this.selectedAccount
        tmpVodService.service_id = this.currentService.service_id
        tmpVodService.user_id = this.currentUser.user_id
      }
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_VOD_SERVICE_LINK', tmpVodService)
        : this.$store.dispatch('Users/CREATE_VOD_SERVICE_LINK', tmpVodService)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
          this.hideSelectService()
          this.$root.$emit('makeToasts')
        }
      })
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    }
  },
  computed: {
    accessCards () {
      let tmp = this.$store.getters['Users/ACCESS_CARDS']
      for (let el of tmp) {
        el.text = el.username + '(' + el.card_number + ')'
        el.value = el.card_number
      }
      return tmp
    },
    fullVODData () {
      return this.$store.getters['Tariffing/VOD_SERVICE']
    }
  },
  mounted () {
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_VOD_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.serviceStats = this.$store.getters['Users/VOD_SERVICE_LINK']
        this.vodService.cost_coef = this.serviceStats.cost_coef * 100
        let newDate = this.$root.setDataWithSelectedTZ().unix()
        if (newDate > this.serviceStats.start_date) {
          this.activeService = true
          this.endDate = this.serviceStats.expire_date
        }
        this.vodService.start_date = this.serviceStats.start_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
      })
    }
    this.$store.dispatch('Tariffing/GET_VOD_SERVICE', this.currentService.service_id)
    this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentUser.user_id)
    if (this.currentService.addByDefault) {
      this.saveVodService()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formVOD.vue